import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import {
    convertValueToStringAndLowerCase,
    getColumnName,
    parseBooleanValue,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/utils";

export class BooleanValueRule extends Validator<IAttributeData[], IAttributeDataError> {
    field: string;
    rule: RuleType;

    constructor(field: string, rule: RuleType) {
        super();
        this.field = field;
        this.rule = rule;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        const fieldName = getColumnName(model[0], this.field);
        let hasError = false;
        if (fieldName && !errors[this.rule]) {
            hasError = model.some((it) => parseBooleanValue(convertValueToStringAndLowerCase(it[fieldName])) === null);
        }

        const validationErrors = hasError
            ? {
                  ...errors,
                  [this.rule]: formatMessage(
                      "Column |field| contains invalid values. Allowed values are: Yes, No, Y, N, TRUE, FALSE.",
                      {
                          field: this.field,
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
